var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import defaultBackground from '@cta-portal/webapp-common/src/assets/images/backgrounds/background-texture.png';
import Loader from '@cta-portal/webapp-common/src/components/loader';
import React, { useContext, useEffect } from 'react';
import Div100vh from 'react-div-100vh';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { RoutePath, generateRoutePath } from '../app/router/config';
import Cookies from '../components/cookies/cookies';
import { CurrencyContext } from '../context/currency';
import { LoadingContext } from '../context/loading';
import { TooltipContext } from '../context/tooltip';
import { UserContext } from '../context/user';
import { appEnv } from '../env';
import Footer from './footer';
import GlobalDialog from './global-dialog';
import GlobalTooltip from './global-tootip';
import Header from './header';
import Main from './main';
export default function Layout(_a) {
    var children = _a.children, fullWidth = _a.fullWidth, withoutMain = _a.withoutMain, background = _a.background, transferAssets = _a.transferAssets;
    var searchParams = useSearchParams()[0];
    var _b = useContext(LoadingContext), imxLoading = _b.imxLoading, serverLoading = _b.serverLoading;
    var setTooltipProps = useContext(TooltipContext).setTooltipProps;
    var _c = useContext(UserContext), user = _c.user, balances = _c.balances;
    var _d = useContext(CurrencyContext), imxClient = _d.imxClient, parseCurrencyQuantity = _d.parseCurrencyQuantity;
    var navigate = useNavigate();
    var location = useLocation();
    useEffect(function () {
        function checkIfTransferIsNeeded() {
            return __awaiter(this, void 0, void 0, function () {
                var listAssetsResponse, ctaBalance, parsedCtaBalance, usdcBalance, parsedUsdcBalance, source;
                var _a, _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            if (!(user && user.magicLinkWalletAddress && user.mpcWalletAddress && !transferAssets)) return [3 /*break*/, 2];
                            return [4 /*yield*/, imxClient.listAssets({
                                    collection: appEnv.blockchain.collectionAddress,
                                    user: user.magicLinkWalletAddress,
                                    pageSize: 1,
                                    status: 'imx',
                                })];
                        case 1:
                            listAssetsResponse = _c.sent();
                            ctaBalance = (_a = balances === null || balances === void 0 ? void 0 : balances.game) === null || _a === void 0 ? void 0 : _a.find(function (balance) { return balance.symbol === 'CTA'; });
                            parsedCtaBalance = ctaBalance
                                ? parseCurrencyQuantity(ctaBalance.balance, ctaBalance.token_address)
                                : undefined;
                            usdcBalance = (_b = balances === null || balances === void 0 ? void 0 : balances.game) === null || _b === void 0 ? void 0 : _b.find(function (balance) { return balance.symbol === 'USDC'; });
                            parsedUsdcBalance = usdcBalance
                                ? parseCurrencyQuantity(usdcBalance.balance, usdcBalance.token_address)
                                : undefined;
                            if (listAssetsResponse.result.length > 0 ||
                                ((parsedCtaBalance === null || parsedCtaBalance === void 0 ? void 0 : parsedCtaBalance.base) && parsedCtaBalance.base.value > 0) ||
                                ((parsedUsdcBalance === null || parsedUsdcBalance === void 0 ? void 0 : parsedUsdcBalance.base) && parsedUsdcBalance.base.value > 0)) {
                                source = searchParams.get('source');
                                navigate(source
                                    ? "".concat(generateRoutePath(RoutePath.TRANSFER_ASSETS_MPC, {}), "?source=").concat(source)
                                    : generateRoutePath(RoutePath.TRANSFER_ASSETS_MPC, {}));
                            }
                            _c.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        }
        if (!transferAssets) {
            checkIfTransferIsNeeded();
        }
    }, [user, balances]);
    useEffect(function () {
        setTooltipProps(undefined);
    }, [location.pathname]);
    useEffect(function () {
        if (user === null &&
            !location.pathname.includes(RoutePath.MARKET.split('/')[1]) &&
            !location.pathname.includes(RoutePath.MY_ASSETS.split('/')[1]) &&
            !location.pathname.includes(RoutePath.CHANGELOG.split('/')[1])) {
            navigate("".concat(generateRoutePath(RoutePath.SIGN_IN, {}), "?next=").concat(encodeURIComponent(window.location.href)));
            return;
        }
    }, [user]);
    return (_jsxs(Container, { background: background, id: "app-container", onScroll: function () { return setTooltipProps(undefined); }, children: [(imxLoading || serverLoading) && _jsx(Loader, { black: true, imx: imxLoading }), _jsx(Header, {}), _jsx(Cookies, {}), user !== undefined && !withoutMain && _jsx(Main, { fullWidth: fullWidth, children: children }), withoutMain && _jsx(_Fragment, { children: children }), _jsx(Footer, {}), _jsx(GlobalDialog, {}), _jsx(GlobalTooltip, {})] }));
}
var Container = styled(Div100vh)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  background: ", ";\n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  overflow-x: hidden;\n  overflow-y: auto;\n  width: 100vw;\n"], ["\n  align-items: center;\n  background: ", ";\n  background-attachment: fixed;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  overflow-x: hidden;\n  overflow-y: auto;\n  width: 100vw;\n"])), function (_a) {
    var background = _a.background;
    return background
        ? "linear-gradient(180deg, #161318 0%, rgba(13, 11, 14, 0.50) 50%, #161318 100%), url(\"".concat(background, "\") lightgray 50%")
        : "url('".concat(defaultBackground, "')");
});
var templateObject_1;
